import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import Middleware from "@/middleware/";
export const regulatory_violation_level = {

    path: "/",
    component: DashboardLayout,
    name: "RegulatoryViolationLevePage",
    children: [
        {
            path: "/regulatory-violation-level",
            name: "RegulatoryViolationLevel",
            component: () => import("@/modules/violations/views/Level/Show.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "",
                permissions: "violation-level-index",
            },
        },





    ],

}

export const regulatory_violation_damage = {

    path: "/",
    component: DashboardLayout,
    name: "RegulatoryViolationPage",
    children: [
        {
            path: "/regulatory-violation-damage",
            name: "RegulatoryViolationDamage",
            component: () => import("@/modules/violations/views/Damage/Show.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "",
                permissions: "violation-damage-index",
            },
        },
    ]
}


export const regulatory_violation_forms = {

    path: "/",
    component: DashboardLayout,
    name: "RegulatoryViolation",
    children: [
        {
            path: "/regulatory-violation-forms",
            name: "RegulatoryViolationForms",
            component: () => import("@/modules/violations/views/Forms/Show.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "violation-form-index",
            },
        },

        {
            path: "/regulatory-violation-forms/new",
            name: "RegulatoryViolationNewForms",
            component: () => import("@/modules/violations/views/Forms/New.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],

                permissions: "violation-form-create",
            },
        },

        {
            path: "/regulatory-violation-forms/edit/:id",
            name: "RegulatoryViolationEditForms",
            component: () => import("@/modules/violations/views/Forms/New.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "violation-form-update",
            },
        },
    ]
}

export const regulatory_violation_order = {

    path: "/",
    component: DashboardLayout,
    name: "RegulatoryViolationOrderPage",
    children: [
        {
            path: "/regulatory-violation-order",
            name: "RegulatoryViolationOrder",
            component: () => import("@/modules/violations/views/Order/Show.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],

                permissions: "violationorder-index",
            },
        },

        {
            path: "/regulatory-violation-order/new",
            name: "RegulatoryViolationOrderNew",
            component: () => import("@/modules/violations/views/Order/New.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "violationorder-create",
            },
        },

        // {
        //     path: "/regulatory-violation-order/edit/:id",
        //     name: "RegulatoryViolationOrderEdit",
        //     component: () => import("@/modules/violations/views/Order/New.vue"),
        //     meta: {
        //         groupName: "RegulatoryViolation",
        //         middlewares: [
        //             Middleware.auth,
        //             Middleware.permission,
        //             Middleware.signeture,
        //         ],

        //         permissions: "violationorder-update",
        //     },
        // },
        {
            path: "/regulatory-violation-order/:id",
            name: "RegulatoryViolationOrderView",
            component: () => import("@/modules/violations/views/Order/View.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "violationorder-view",
            },
        },

        {
            path: "/regulatory-violation-order/log/:id",
            name: "RegulatoryViolationOrderLog",
            component: () => import("@/modules/violations/views/Order/Log.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "violationorder-view",
            },
        },

        // {
        //     path: "/regulatory-violation-order/ready/:id",
        //     name: "RegulatoryViolationOrderReady",
        //     component: () => import("@/modules/violations/views/Order/Ready.vue"),
        //     meta: {
        //         groupName: "RegulatoryViolation",
        //         middlewares: [
        //             Middleware.auth,
        //             Middleware.permission,
        //             Middleware.signeture,
        //         ],
        //         permissions: "",
        //     },
        // },
        {
            path: "/regulatory-violation-unassigned-order",
            name: "RegulatoryViolationOrderUnassigned",
            component: () => import("@/modules/violations/views/Order/unAssignCamp/Show_un_assign_camps.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "violationorder-index",
            },
        },
        {
            path: "/regulatory-violation-unassigned-order/new",
            name: "RegulatoryViolationOrderUnassignedNew",
            component: () => import("@/modules/violations/views/Order/unAssignCamp/new_un_assign_camps.vue"),
            meta: {
                groupName: "RegulatoryViolation",
                middlewares: [
                    Middleware.auth,
                    Middleware.permission,
                    Middleware.signeture,
                ],
                permissions: "violationorder-create",
            },
        },
    ]
}
